import React, { Component } from "react";
import styles from "./css/MiddleContainer.module.css";
// import ProfilePic from './Image/DashboardImages/postModImages/profilepic.jpg'
import DropBox from "./DropBox";
import Video from "../Components/Video";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import {
  Avatar,
  Box,
  Button,
  Chip,
  IconButton,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import VisibilityModal from "../VisibilityModal/VisibilityModal";
import OccasionModal from "../OccasionModal/OccasionModal";
import EventModal from "../EventModal/EventModal";
import PollModal from "../PollModal/PollModal";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import ExpertModal from "../ExpertModal/ExpertModal";
import PollDisplay from "../Components/PollDisplay";
import ExpertDisplay from "../Components/ExpertDisplay";
import SellModal from "../SellModal/SellModal";
import LocationModal from "../LocationModal/LocationModal";
import PDFViewer from "./PDFViewer";
import SellDisplay from "../Components/SellDisplay";
import PublicIcon from "@mui/icons-material/Public";
import FmdGoodIcon from "@mui/icons-material/FmdGood";
import EventDisplay from "../Components/EventDisplay";
import PollDisplayGroup from "../Components/PollDisplayGroup";

const GoogleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
const lat = JSON.parse(localStorage.getItem("lat"));
const lng = JSON.parse(localStorage.getItem("lng"));

class MiddleContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: "Anyone",
      userVoted: [],
      options: ["Anyone"],
      hashtag: {
        target: {
          value: "#",
        },
      },
      value:
        this.props?.actionType == "EDIT"
          ? this.props?.postData?.description
          : "",
    };
  }

  changeActiveElement = (item) => {
    this.setState({ selectedOption: item });
  };

  updateSelectedOption = (e) => {
    this.setState({ selectedOption: e.target.value });
  };

  updateValue = (e) => {
    this.setState({ value: e.target.value });
    this.props.onChange(e);
  };

  updateValueMessage = (msg) => {
    this.setState({ value: msg });
    this.props.onChangeMessage(msg);
  };

  setUserVoted = (item) => {
    this.setState({ userVoted: item });
  };

  render() {
    return (
      <div>
        <LocationModal
          show={this.props.showLocationModal}
          closeModal={this.props.LocationModalCloser}
          method={this.props.handleAddress}
          coordinates={this.props.coordinates}
          setCoordinates={this.props.handleCoordinatesChange}
        />
        {this.props.showVisibilityModal && (
          <VisibilityModal
            show={this.props.showVisibilityModal}
            closeModal={this.props.VisibilityModalCloser}
            selectedOption={this.state.selectedOption}
            updateSelectedOption={this.updateSelectedOption}
          />
        )}
        {this.props.showOccasionModal && (
          <OccasionModal
            show={this.props.showOccasionModal}
            closeModal={this.props.OccasionModalCloser}
            message={this.state.value}
            updateValueMessage={this.updateValueMessage}
            fileInput={this.props.fileInput}
            pic={this.props.pic}
          />
        )}
        {this.props.showEventModal && (
          <EventModal
            show={this.props.showEventModal}
            closeModal={this.props.EventModalCloser}
            fileInput={this.props.fileInput}
            pic={this.props.pic}
            updateValueMessage={this.updateValueMessage}
            updateEventPost={this.props.updateEventPost}
            updateCoordinates={this.props.updateCoordinates}
            eventPost={this.props.eventPost}
          />
        )}
        {this.props.showPollModal && (
          <PollModal
            show={this.props.showPollModal}
            closeModal={this.props.PollModalCloser}
            updatePollPost={this.props.updatePollPost}
            pollPost={this.props.pollPost}
          />
        )}
        {this.props.showExpertModal && (
          <ExpertModal
            show={this.props.showExpertModal}
            closeModal={this.props.ExpertModalCloser}
            updateValueMessage={this.updateValueMessage}
            UpdateExpertPost={this.props.UpdateExpertPost}
            expertPost={this.props.expertPost}
          />
        )}
        {this.props.showSellModal && (
          <SellModal
            show={this.props.showSellModal}
            setShowSellModal={this.props.setShowSellModal}
            fileInput={this.props.fileInput}
            pic={this.props.pic}
            updateSellPost={this.props.updateSellPost}
            updateCoordinates={this.props.updateCoordinates}
            sellPost={this.props.sellPost}
            actionType={this.props.actionType}
            postId={this?.props?.postId}
          />
        )}
        {!this.props.showVisibilityModal &&
          !this.props.showEventModal &&
          !this.props.showOccasionModal &&
          !this.props.showPollModal &&
          !this.props.showExpertModal &&
          !this.props.showSellModal && (
            <div>
              {this.props.actionType == "EDIT" ||
              this.props.actionType == "ADD" ? (
                <div style={{ padding: "0px 0px 0px 20px" }}>
                  <div className={styles.container}>
                    <Button
                      onClick={this.props.VisibilityModalOpener}
                      disableRipple
                      sx={{
                        textTransform: "capitalize",
                        ":hover": { background: "rgba(0,0,0,0.08)" },
                        borderRadius: "15px",
                        padding: "10px 10px",
                        alignItems: "center",
                        display: "flex",
                      }}
                    >
                      <img
                        className={styles.profilePic}
                        src={
                          this.props.profilePicUrl
                            ? this.props.profilePicUrl
                            : this.props.avatarImg
                            ? this.props.avatarImg
                            : "/Image/header/ddefault_img.svg"
                        }
                        alt="Profile Pic"
                      />

                      <div
                        style={{
                          marginLeft: 16,
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-start",
                        }}
                      >
                        <Typography
                          sx={{
                            color: "#666666",
                            fontSize: "17px",
                            fontWeight: 500,
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          {this.props.name ??
                            this.props.user.first_name +
                              " " +
                              this.props.user.last_name ??
                            ""}
                          {/* <ArrowDropDownIcon
                            fontSize="large"
                            sx={{ color: "primary.black" }}
                          /> */}
                        </Typography>
                        <Chip
                          icon={<PublicIcon color="#9d9d9d" />}
                          label={this.state.selectedOption}
                          size="small"
                          sx={{ background: "#f6f7f9", color: "#9d9d9d" }}
                        />
                        {/* <Typography
                          sx={{
                            color: "primary.black",
                            fontSize: "14px",
                            fontWeight: 400,
                            textAlign: "left",
                            ml: 1,
                            lineHeight: 1,
                          }}
                        >
                          Post to {this.state.selectedOption}
                        </Typography> */}
                      </div>
                    </Button>
                    <Button
                      onClick={this.props.LocationModalOpener}
                      disableRipple
                      size="small"
                      sx={{
                        textTransform: "none",
                        color: "#fff",
                        background: "#049948",
                        borderRadius: "10px",
                        px: 1,
                        "& .MuiButton-startIcon": { marginRight: "5px" },
                        ":hover": {
                          background: "#049948",
                        },
                        display: { xs: "none", sm: "flex" },
                      }}
                      startIcon={
                        <Avatar
                          variant="square"
                          src="/Image/DashboardImages/postModImages/loc_icon.svg"
                          sx={{ color: "#fff", width: "auto", height: "18px" }}
                        />
                      }
                    >
                      Add Location
                    </Button>
                    <IconButton
                      onClick={this.props.LocationModalOpener}
                      disableRipple
                      sx={{
                        display: { xs: "block", sm: "none" },
                        background: "#049948",
                        px: "14px",
                        ":hover": {
                          background: "#049948",
                        },
                      }}
                    >
                      <img
                        alt="location button"
                        src="/Image/DashboardImages/postModImages/loc_icon.svg"
                        style={{ width: "auto", height: "18px" }}
                      />
                    </IconButton>
                  </div>

                  <div
                    style={{
                      overflowY: "auto",
                      minHeight: "40vh",
                      maxHeight: "45vh",
                    }}
                  >
                    <div className={styles.textareaContainer}>
                      <TextField
                        variant="standard"
                        onChange={(e) => this.updateValue(e)}
                        type="text"
                        placeholder={this.props.t("dashboard.modalThoughts")}
                        multiline
                        rows={4}
                        value={this.state.value}
                        InputProps={{
                          disableUnderline: true,
                        }}
                        inputProps={{
                          style: {
                            fontSize: "20px",
                          },
                        }}
                        sx={{
                          width: "100%",
                        }}
                      />
                    </div>

                    {this.props?.eventPost && (
                      <EventDisplay
                        eventPost={this.props?.eventPost}
                        actionType={this.props.actionType}
                        EventModalOpener={this.props.EventModalOpener}
                        updateEventPost={this.props.updateEventPost}
                      />
                    )}

                    <div
                      style={{
                        position: "relative",
                        textAlign: "center",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      {this.props.pic || this.props.video ? (
                        <>
                          <Box sx={{ position: "relative" }}>
                            {!this.props.video ? (
                              <img
                                src={this.props?.pic}
                                style={{
                                  width: "95%",
                                  height: "auto",
                                  objectFit: "contain",
                                  borderRadius: "8px",
                                }}
                              />
                            ) : (
                              <Video src={this.props.video} />
                            )}
                            <IconButton
                              onClick={
                                this.props.pic
                                  ? this.props.handleRemoveImage
                                  : this.props.handleRemoveVideo
                              }
                              disableRipple
                              sx={{
                                position: "absolute",
                                right: 23,
                                background: "#666",
                                padding: "5px",
                                top: 7,
                                ":hover": {
                                  background: "#666",
                                },
                              }}
                            >
                              <CloseIcon
                                fontSize="small"
                                sx={{ color: "#fff" }}
                              />
                            </IconButton>
                          </Box>
                        </>
                      ) : null}
                    </div>

                    {this.props?.file ? (
                      <>
                        <Box>
                          <PDFViewer
                            url={this.props?.file}
                            width={
                              window.innerWidth <= 400
                                ? 270
                                : window.innerWidth <= 600
                                ? 350
                                : window.innerWidth <= 800
                                ? 380
                                : 580
                            }
                            handleRemovePdf={this.props.handleRemovePdf}
                          />
                        </Box>
                      </>
                    ) : null}

                    {this.props?.pollPost ? (
                      <>
                        {this.props.source === "GROUP" ? (
                          <PollDisplayGroup
                            pollPost={this.props.pollPost}
                            PollModalOpener={this.props.PollModalOpener}
                            updatePollPost={this.props.updatePollPost}
                            actionType={this.props.actionType}
                            userVoted={this.state.userVoted}
                            setUserVoted={this.setUserVoted}
                          />
                        ) : (
                          <PollDisplay
                            pollPost={this.props.pollPost}
                            PollModalOpener={this.props.PollModalOpener}
                            updatePollPost={this.props.updatePollPost}
                            actionType={this.props.actionType}
                            userVoted={this.state.userVoted}
                            setUserVoted={this.setUserVoted}
                          />
                        )}
                      </>
                    ) : null}

                    {this.props.expertPost ? (
                      <ExpertDisplay
                        expertPost={this.props?.expertPost}
                        ExpertModalOpener={this.props.ExpertModalOpener}
                        UpdateExpertPost={this.props.UpdateExpertPost}
                        actionType={this.props.actionType}
                      />
                    ) : null}

                    {this.props?.sellPost ? (
                      <SellDisplay
                        sellPost={this.props?.sellPost}
                        actionType={this.props.actionType}
                        setShowSellModal={this.props.setShowSellModal}
                      />
                    ) : null}

                    {this.props.coordinates.address !== null &&
                    !this.props?.sellPost &&
                    !this.props?.eventPost ? (
                      <Box sx={{ position: "relative" }}>
                        <img
                          src={`https://maps.googleapis.com/maps/api/staticmap?center=${this.props.coordinates.lat},${this.props.coordinates.lng}&zoom=17&size=700x200&markers=icon:http://stage-nxnearby-assets.s3.ap-south-1.amazonaws.com/media/static/favicon.ico|${this.props.coordinates.lat},${this.props.coordinates.lng}&maptype=terrain&key=${GoogleMapsApiKey}&style=feature:administrative.land_parcel%7Celement:geometry.fill%7Cweight:4&style=feature:administrative.land_parcel%7Celement:labels.text.fill%7Ccolor:0xbdbdbd&style=feature:administrative.locality%7Celement:geometry.fill%7Cweight:5&style=feature:administrative.neighborhood%7Celement:geometry.fill%7Cweight:5.5&style=feature:administrative.province%7Celement:geometry.fill%7Ccolor:0xffdfba&style=feature:landscape%7Celement:geometry.fill%7Ccolor:0xfcfcfc&style=feature:landscape.natural.landcover%7Celement:geometry.fill%7Ccolor:0xe9f7c4&style=feature:landscape.natural.terrain%7Celement:geometry.fill%7Ccolor:0xffdfba&style=feature:poi%7Celement:labels.text.fill%7Ccolor:0x757575&style=feature:poi%7Celement:labels.text.stroke%7Ccolor:0xffffff&style=feature:poi.attraction%7Celement:geometry.fill%7Cweight:5&style=feature:poi.business%7Celement:geometry.fill%7Ccolor:0xffdfba&style=feature:poi.government%7Celement:geometry.fill%7Ccolor:0xffdfba%7Cweight:4&style=feature:poi.medical%7Celement:geometry.fill%7Cweight:4.5&style=feature:poi.park%7Celement:geometry.fill%7Ccolor:0xbaffc9&style=feature:poi.park%7Celement:labels.text.fill%7Ccolor:0x9e9e9e&style=feature:poi.place_of_worship%7Cvisibility:off&style=feature:poi.place_of_worship%7Celement:geometry.fill%7Ccolor:0xffb3ba&style=feature:poi.school%7Celement:geometry.fill%7Ccolor:0xffdfba&style=feature:poi.sports_complex%7Celement:geometry.fill%7Ccolor:0xffdfba&style=feature:road%7Celement:geometry%7Ccolor:0xffffff&style=feature:road%7Celement:geometry.fill%7Clightness:10&style=feature:road.arterial%7Celement:labels.text.fill%7Ccolor:0x757575&style=feature:road.highway%7Celement:geometry%7Ccolor:0xdadada&style=feature:road.highway%7Celement:labels.text.fill%7Ccolor:0x616161&style=feature:road.local%7Celement:geometry.fill%7Ccolor:0xe0e0e0%7Clightness:40%7Cweight:5&style=feature:transit.line%7Celement:geometry%7Ccolor:0xe5e5e5&style=feature:transit.station%7Celement:geometry%7Ccolor:0xeeeeee&style=feature:water%7Celement:geometry%7Ccolor:0xc9c9c9&style=feature:water%7Celement:geometry.fill%7Ccolor:0xc0faff&style=feature:water%7Celement:labels.text.fill%7Ccolor:0x9e9e9e`}
                          style={{
                            marginTop: 16,
                            borderRadius: 16,
                            width: "95%",
                          }}
                        />
                        <IconButton
                          disableRipple
                          onClick={this.props.removeLocationPost}
                          sx={{
                            background: "#666",
                            padding: "5px",
                            position: "absolute",
                            right: 45,
                            top: 25,
                          }}
                        >
                          <CloseIcon fontSize="small" sx={{ color: "#fff" }} />
                        </IconButton>
                      </Box>
                    ) : null}
                  </div>
                </div>
              ) : (
                <Box sx={{ p: "20px 50px", fontSize: "18px", fontWeight: 500 }}>
                  {this.props.t("dashboard.sureDelete")}
                </Box>
              )}
            </div>
          )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  //U can destructure here to get only the required attributes from the state
  return {
    user: state.profile.user || "",
    name: state.profile.name || "",
    profilePicUrl: state.profile.userProfilePic,
    avatarImg: state.profile.avatarImg,
  };
};

export default withTranslation()(
  connect(mapStateToProps, null)(MiddleContainer)
);
